import UserInitials, { UserInitialsProps } from './UserInitials.container';

export type { UserInitialsProps };

export default UserInitials;
